// import ChartV5 from '../../pages/conocimiento/ChartV5';
import ChartV5 from '../../pages/Conocimiento-Aprobacion/ChartV5';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '0' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* <ChartV5/> */}
            <ChartV5 />
          </div>
        </div>
      </div>
    </div>
  )
}
